module.exports = __webpack_public_path__ + "img/icon_3.f33f0597.png";